import { Language, UserLanguages } from '@moodys/cre-cpm.models.localization';

export const userLanguages: UserLanguages = {
  en: {
    key: 'en',
    locale: 'en-US',
    billionSymbol: 'B',
    regexp: {
      decimal: /,/g,
      group: /\./g,
    },
    formats: {
      decimal: '.',
      group: ',',
    },
  },
  de: {
    key: 'de',
    locale: 'de-DE',
    billionSymbol: 'Mrd',
    regexp: {
      decimal: /\./g,
      group: /,/g,
    },
    formats: {
      decimal: ',',
      group: '.',
    },
  },
};

export const DefaultLanguage: Language = 'en';
